import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { fontDisplay, fontUi, pill, viewMoreLink } from '../../../../theme/typography';

export const StyledSection = styled.section`
  display: flex;
  flex-direction: column;
  ${({ $contained, theme }) => $contained && css`
    box-sizing: border-box;
    background: ${theme.card};
    border: 1px solid ${theme.border};
    border-radius: ${theme.cardRadius};
    box-shadow: 0 8px 24px rgba(0, 0, 0, ${theme.isDark ? 0.24 : 0.04});
    overflow: hidden;
    height: 100%;
    > h3 {
      ${fontDisplay};
      line-height: 1.2;
      letter-spacing: -0.02em;
      display:flex; align-items:center; justify-content:space-between; gap:12px;
      margin: 0;
      padding: 10px 20px;
      font-size: 16px;
      border-bottom: 1px solid ${theme.borderSubtle};
      flex-shrink: 0;
    }
    > div { padding: 0 12px; flex: 1; min-height: 0; display: flex; flex-direction: column; }
  `}
  grid-area: calendar;
  min-width: 0;
  width: 100%;
`;

export const StyledViewMore = styled(Link)`
  ${viewMoreLink};
  svg {
    display: block;
    width: 12px;
    height: 12px;
  }
`;

export const StyledCrest = styled.img`
  width: 34px;
  height: 34px;
  border-radius: 0;
  object-fit: contain;
  flex-shrink: 0;
  background: transparent;
`;

export const StyledCopy = styled.span`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
`;

export const StyledTypePill = styled.span`
  ${pill};
  flex-shrink: 0;
  padding: 6px 10px;
  font-size: 11px;
  font-weight: 600;
  background: ${({ theme }) => (theme.isDark ? theme.hover : '#ececec')};
  color: ${({ theme }) => theme.text};
`;

export const StyledMatchTop = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-width: 0;
`;

export const StyledMatchBottom = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  min-width: 0;
`;

export const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background: transparent;
  min-height: ${({ $compact }) => ($compact ? '0' : '260px')};
  ${({ $horizontal, theme }) => $horizontal && css`
    display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:10px; padding:12px !important; align-items:stretch; flex:1;
    > button {
      border:1px solid ${theme.borderSubtle};
      border-radius:${theme.controlRadius};
      padding:12px;
      min-height:96px;
      height:100%;
      flex-direction:column;
      align-items:stretch;
      justify-content:space-between;
      gap:10px;
      flex-wrap:nowrap;
    }
    > button ${StyledCrest} { width:28px; height:28px; }
    @media(max-width:1199px) {
      grid-template-columns:1fr; gap:0; padding:0 14px !important; align-items:stretch;
      > button {
        min-height:0; height:auto; flex-direction:row; align-items:center; justify-content:flex-start;
        flex-wrap:nowrap; border:0; border-radius:0; padding:12px 0; gap:10px;
      }
      > button ${StyledMatchTop} { flex:1; min-width:0; }
      > button ${StyledMatchBottom} { width:auto; flex-shrink:0; }
      > button + button {border-top:1px solid ${theme.borderSubtle};}
    }
    @container (max-width:640px) {
      grid-template-columns:1fr;
      > button { flex-direction:row; align-items:center; min-height:0; height:auto; }
    }
  `}
`;

export const StyledRow = styled.button`
  ${fontUi};
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 0;
  min-height: 56px;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
  flex: ${({ $compact }) => ($compact ? '0 0 auto' : '1 1 auto')};
  box-sizing: border-box;
  & + & {
    border-top: 1px solid ${({ theme }) => theme.borderSubtle};
  }
`;

export const StyledName = styled.span`
  ${fontUi};
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.text};
  line-height: 1.2;
  overflow-wrap: normal;
`;

export const StyledDate = styled.span`
  ${fontUi};
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;
  overflow-wrap: anywhere;
  color: ${({ theme }) => theme.textFaint};
`;

export const StyledEmpty = styled.p`
  ${fontUi};
  margin: auto;
  padding: 24px 16px;
  text-align: center;
  color: ${({ theme }) => theme.textFaint};
  font-size: 13px;
`;
